import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import styles from '../styles/ShipmentMethodSkeleton.style';

const ShippingMethodRow = (classNames) => {
  return (
    <>
      <Row fullBleed>
        <LoaderSkelton width="100%" borderRadius="16px" className={classNames} />
      </Row>
    </>
  );
};

const DeliveryMethod = () => {
  return (
    <>
      <Col colSize={{ small: 4, medium: 2, large: 1 }} className="delivery-method">
        <LoaderSkelton width="100%" borderRadius="16px" />
      </Col>
    </>
  );
};

const ShippingMethodSkeleton = ({ className }) => {
  return (
    <div className={`${className} spc-card-container`}>
      <div className="spc-card-skeleton">
        <Row fullBleed>
          {DeliveryMethod()}
          {DeliveryMethod()}
          {DeliveryMethod()}
        </Row>
        {ShippingMethodRow('edd-details')}
        {ShippingMethodRow('edd-details-two')}
      </div>
    </div>
  );
};

ShippingMethodSkeleton.propTypes = {
  className: PropTypes.string.isRequired,
};

export default withStyles(ShippingMethodSkeleton, styles);
export { ShippingMethodSkeleton as ShippingMethodSkeletonVanilla };
